import React from 'react';
import appNavigationNames, { withActiveTab } from '../../utils/appNavigationNames';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { getIntl } from '../../utils/intl';
import { screens } from '../screens/Tabs/Account';
import { MaybeDrawerLayout } from '../shared/MaybeSideNavLayout';
import { colors } from '../../utils/theme';
import { getHeader, mobileHeaderConfigs } from '../v2BaseComponents/Header';
import { useCapturedUrlUTMParameters } from '../../hooks/useUrlUTMParameters';

const intl = getIntl('accountNavigation', {
    accountInformation: 'Account Information',
    subscriptionPlans: 'Subscription Plans',
    support: 'Support',
    preferences: 'Preferences',
    about: 'About',
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    feedbackAndRoadmap: 'Feedback & Roadmap',
    root: 'My Account',
    accountDeletionConfirmation: 'Account Deletion Confirmation',
    redirect: 'Welcome Back',
});

const Stack = createNativeStackNavigator();

const AccountNavigation = () => {
    const capturedUrlUTMParameters = useCapturedUrlUTMParameters();

    return (
        <MaybeDrawerLayout>
            <Stack.Navigator initialRouteName={appNavigationNames.account.root}>
                <Stack.Screen
                    options={{
                        header: getHeader({
                            mobile: mobileHeaderConfigs.backDisabledStandard,
                            breadCrumbs: ['account-root'],
                        }),
                        title: intl('root'),
                        contentStyle: {
                            backgroundColor: colors.Background,
                        },
                    }}
                    name={appNavigationNames.account.root}
                    component={screens.AccountScreen}
                    initialParams={capturedUrlUTMParameters}
                />
                <Stack.Screen
                    options={{
                        header: getHeader({
                            mobile: mobileHeaderConfigs.standard,
                            breadCrumbs: ['account-root', 'account-information'],
                        }),
                        title: intl('accountInformation'),
                        contentStyle: {
                            backgroundColor: colors.Background,
                        },
                    }}
                    name={appNavigationNames.account.information}
                    component={screens.AccountInformationScreen}
                    initialParams={capturedUrlUTMParameters}
                />
                <Stack.Screen
                    options={{
                        header: getHeader({
                            mobile: mobileHeaderConfigs.standard,
                            breadCrumbs: [],
                        }),
                        title: intl('support'),
                        contentStyle: {
                            backgroundColor: colors.Background,
                        },
                    }}
                    name={appNavigationNames.account.support}
                    component={screens.SupportScreen}
                    initialParams={capturedUrlUTMParameters}
                />
                <Stack.Screen
                    options={{
                        header: getHeader({
                            mobile: mobileHeaderConfigs.standard,
                            breadCrumbs: ['account-root', 'subscription-plans'],
                        }),
                        contentStyle: {
                            backgroundColor: colors.Background,
                        },
                        title: intl('subscriptionPlans'),
                    }}
                    name={appNavigationNames.account.subscription}
                    component={screens.SubscriptionScreen}
                    initialParams={capturedUrlUTMParameters}
                />
                <Stack.Screen
                    options={{
                        header: getHeader({
                            mobile: mobileHeaderConfigs.standard,
                            breadCrumbs: ['account-root', 'account-deletion-confirm'],
                        }),
                        contentStyle: {
                            backgroundColor: colors.Background,
                        },
                        title: intl('accountDeletionConfirmation'),
                    }}
                    name={appNavigationNames.account.accountDeletionConfirmation}
                    component={screens.AccountDeletionConfirmationScreen}
                    initialParams={capturedUrlUTMParameters}
                />
                <Stack.Screen
                    options={{
                        header: getHeader({
                            mobile: mobileHeaderConfigs.standard,
                            breadCrumbs: ['account-root', 'preferences'],
                        }),
                        contentStyle: {
                            backgroundColor: colors.Background,
                        },
                        title: intl('preferences'),
                    }}
                    name={appNavigationNames.account.preferences}
                    component={screens.PreferencesScreen}
                    initialParams={capturedUrlUTMParameters}
                />
                <Stack.Screen
                    options={{
                        title: intl('redirect'),
                        header: getHeader({ mobile: mobileHeaderConfigs.standard }),
                    }}
                    name={appNavigationNames.account.redirect}
                    component={screens.RedirectScreen}
                    initialParams={capturedUrlUTMParameters}
                />
            </Stack.Navigator>
        </MaybeDrawerLayout>
    );
};

export default withActiveTab(AccountNavigation, 'account');
